import styled from 'styled-components';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';

type JourneyViewCertificateBannerProps = {
  firstName?: string;
  onSeeCertificate: () => void;
};

const RootStyled = styled.section`
  background-color: ${({ theme }) => theme.tones.primary[99]};
  border-radius: 8px;
  padding: 1px;
  width: 100%;
`;

const ContainerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;
`;

const IconWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 68px;
  height: 68px;
  font-size: 36px;
  color: ${({ theme }) => theme.colors.primary.onContainer};
`;

const BodyStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
`;

const TitleStyled = styled.h2`
  ${({ theme }) => theme.typography.title3};
  color: ${({ theme }) => theme.colors.primary.onContainer};
  margin: 0;
`;

const SubtitleStyled = styled.p`
  ${({ theme }) => theme.typography.body1};
  color: ${({ theme }) => theme.colors.neutral.onContainer};
  margin: 0;
`;

export const JourneyViewCertificateBanner = ({ firstName, onSeeCertificate }: JourneyViewCertificateBannerProps): JSX.Element => {
  const trimmedName = firstName?.trim();
  const greeting = trimmedName ? `Amazing work, ${trimmedName}!` : 'Amazing work!';

  return (
    <RootStyled aria-labelledby="certificate-banner-heading">
      <ContainerStyled>
        <IconWrapperStyled>
          <Icon icon={['far', 'party-horn']} />
        </IconWrapperStyled>
        <BodyStyled>
          <TitleStyled id="certificate-banner-heading">{greeting}</TitleStyled>
          <SubtitleStyled>Your certificate is ready to download.</SubtitleStyled>
        </BodyStyled>
        <Button variant="primary" size="large" onClick={onSeeCertificate}>
          See certificate
        </Button>
      </ContainerStyled>
    </RootStyled>
  );
};
